import type { ReactNode } from 'react';
import type { PayformCapabilityEnum } from '@am3nd-org/pointcraft-types';

import { usePayformsAccess } from 'src/online-payment/hooks/usePayformsAccess';

import { PayformsForbiddenView } from './PayformsStateViews';

/* =================== PAYFORMS ACCESS GUARD =================== */

/**
 * Route-level hide/show for the Payforms pages (DEC-P2-03 V2, DEC-P2-11).
 *
 * It renders an honest "no access" view instead of redirecting, so a user who
 * followed a link understands why the page is empty. It is NOT authorization:
 * every `/api/business/payforms/**` route is authorised by the backend with the
 * same capability definition, and a forged client state only ever reaches a
 * 403 there.
 */

type PayformsAccessGuardProps = {
  capability: `${PayformCapabilityEnum}`;
  children: ReactNode;
};

export default function PayformsAccessGuard({ capability, children }: PayformsAccessGuardProps) {
  const access = usePayformsAccess();

  if (!access[capability]) {
    return <PayformsForbiddenView capability={capability} identified={access.identified} />;
  }

  return <>{children}</>;
}
